import { render, staticRenderFns } from "./machine.vue?vue&type=template&id=672cb6de&scoped=true&"
import script from "./machine.vue?vue&type=script&lang=js&"
export * from "./machine.vue?vue&type=script&lang=js&"
import style0 from "./machine.vue?vue&type=style&index=0&id=672cb6de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672cb6de",
  null
  
)

export default component.exports